import {
  IDtvButtonProps
} from "@directv-digital/dds.ui.dtv-button";
import { IDtvTextProps } from "@directv-digital/dds.ui.dtv-text";
import { TonalIconProps } from "./components/TonalIcon";
import { ComparePkgTray } from "../ComparePackageTray";

export interface PackageCarouselProps {
  id: string;
  type: string;
  background: string;
  config: PackageCarouselConfig;
  title: IDtvTextProps;
  subHeading: IDtvTextProps;
  bodyText: IDtvTextProps;
  priceText: PackageCarouselPriceText;
  cta: PackageCarouselCta;
  secondaryCta: PackageCarouselCta;
  cards: CarouselCard[];
  myFreeConfig: PackageCarouselMyFreeConfigProps;
  controlsConfig: ControlsConfig;
  genrePacks?: any;
  signaturePacks?: any;
  comparePkgTray?: ComparePkgTray;
}
export interface PackageCarouselConfig {
  isAutoScrollNeeded?: boolean;
  scrollSpeed?: number;
  isLeftRightControlsNeeded?: boolean;
  productType?: string;
  isCtaPositionBottom?: boolean;
}

export interface PackageCarouselPriceText extends IDtvTextProps {
  spanText?: IDtvTextProps;
  legal?: IDtvTextProps;
  bodyText?: IDtvTextProps;
}

export interface PackageCarouselCta extends IDtvButtonProps {
  buttontype?: "primary" | "secondary" | "tertiary";
  color: any;
  background: string;
  border: string;
  boxShadow: string;
  hover: {
    color: any;
    background: string;
    border: string;
  }
}

export interface PackageCarouselMyFreeConfigProps {
  id: string;
  logo: string;
  background: string;
  body: IDtvTextProps;
  alt?: string;
  downArrow?: {
    alt?: string;
    icon?: string;
  };
}

export interface ControlsConfig {
  playIcon: TonalIconProps;
  pauseIcon: TonalIconProps;
  prevIcon: TonalIconProps;
  nextIcon: TonalIconProps;
}

export interface CarouselCard {
  pkgType?: string;
  background?: string;
  boxShadow?: string;
  queryparam?: string;
  title?: IDtvTextProps;
  subHeading?: IDtvTextProps;
  topper?: CarouselCardTopper;
  images?: CarouselCardImage[] | CarouselCardImage;
  bodyText?: CarouselCardBodyText;
  offerRibbon?: CarouselCardOfferRibbon;
  strikeThroughPrice?: IDtvTextProps;
  priceText?: CarouselCardBodyText;
  rightArrow?: CarouselCardRightArrow;
  config: CarouselCardConfig;
  modalData: any;
  svods?: CarouselCardSvod[];
  ariaLabel?: string;
}

export interface CarouselCardTopper extends IDtvTextProps {
  background?: string;
}

export interface CarouselCardImage {
  url?: any;
  alt?: string;
  width?: {
    xs: string;
    sm: string;
    md: string;
  };
  height?: {
    xs: string;
    sm: string;
    md: string;
  };
  objectFit?: {
    xs: React.CSSProperties["objectFit"];
    sm: React.CSSProperties["objectFit"];
    md: React.CSSProperties["objectFit"];
  };
}

export interface CarouselCardBodyText extends IDtvTextProps {
  spanText?: IDtvTextProps;
}

export interface CarouselCardOfferRibbon extends IDtvTextProps {
  background?: string;
}

export interface CarouselCardConfig {
  type?: string;
  isZipcodeModuleNeeded?: boolean;
  id?: string;
  targeturl: IDtvButtonProps;
}

export interface PackageCarouselTopperProps {
  title: IDtvTextProps;
  subHeading: IDtvTextProps;
  bodyText: IDtvTextProps;
  priceText: PackageCarouselPriceText;
  cta: PackageCarouselCta;
  secondaryCta: PackageCarouselCta;
  config: PackageCarouselConfig;
}

export interface CtaSectionProps {
  cta: PackageCarouselCta;
  secondaryCta: PackageCarouselCta;
}

export interface CarouselProps {
  cards: CarouselCard[];
}

export interface CarouselCardProps {
  card?: CarouselCard;
  index?: number;
  handleCardClick?: () => void;
  cardWidth?: string | number;
  myFreeConfig?: PackageCarouselMyFreeConfigProps;
  svods?: CarouselCardSvod[];
}

export interface CarouselCardSvod {
  name: string;
  logo: SvodLogo;
  code: string;
  disable: boolean;
}

export interface SvodLogo {
  mobile?: string;
  tablet?: string;
  default?: string;
}

export interface CarouselCardRightArrow {
  icon?: string;
  alt?: string;
  color?: string;
  background?: string;
}

export interface CardModalContentProps {
  title: IDtvTextProps;
  subHeading: CarouselCardBodyText;
  offerRibbon: CarouselCardOfferRibbon;
  strikeThroughPrice: IDtvTextProps;
  priceText: PackageCarouselPriceText;
  channelsLabel: IDtvTextProps;
  localChannelsText: IDtvTextProps;
  channels: Channel[];
  rsnTeamsTableData: MyHomeRsnTableProps;
  myFreeConfig: PackageCarouselMyFreeConfigProps;
  config?: CarouselCardConfig;
}

export interface MyHomeRsnTableProps {
  title: IDtvTextProps;
  legal: IDtvTextProps;
  teams: string[];
  errorMessage: IDtvTextProps;
  teamsTitle: CarouselCardTopper;
  channelsTitle: CarouselCardTopper;
  channelName: IDtvTextProps;
  channelNumber: IDtvTextProps;
  teamName: IDtvTextProps;
  tableBodyBackground: string;
}

// export MARGIN_15
export const MARGIN_15 = 15;

export interface Channel {
  channelNameLabel?: string;
  channelLogoPath?: string;
}

export interface ModalTopSectionProps {
  title: IDtvTextProps;
  subHeading: CarouselCardBodyText;
  offerRibbon: CarouselCardOfferRibbon;
  strikeThroughPrice: IDtvTextProps;
  priceText: PackageCarouselPriceText;
}

export interface ModalChannelsSectionProps {
  channelsLabel: IDtvTextProps;
  localChannelsText: IDtvTextProps;
  channels: Channel[];
}
